import { isWeb, shadowStandard, SizableText, SmartLink, Stack, XStack, YStack } from '@my/ui'
import { SaveOfferButton } from '../../containers'
import { LinearGradient } from '@tamagui/linear-gradient'
import { Offer } from '../../screens/offer-screen/queries'
import { SolitoImage } from 'solito/image'

export interface OfferCardProps {
  id: string
  name: string
  description: string
  slug: string
  brand: {
    slug: string
    logo?: {
      url: string
      alt?: string
    }
  }
  thumbnailImage: Offer['thumbnailImage']
  imagePriority?: boolean
  isBookmarked: boolean
}

export const OfferCard = (props: OfferCardProps) => {
  return (
    <YStack flex={1} br="$3" overflow="hidden" position="relative" minHeight={245}>
      <Stack pos="absolute" flex={1} overflow="hidden" h="100%" w="100%">
        <SolitoImage
          src={props.thumbnailImage?.url}
          alt={props.name}
          contentFit="cover"
          fill
          sizes="(max-width: 576px) 50vw, 437px"
          priority={props.imagePriority}
        />
      </Stack>

      <XStack zIndex="$1" position="absolute" top="$3.5" right="$3.5">
        <SaveOfferButton size={24} offerId={props.id} isBookmarked={props.isBookmarked} />
      </XStack>

      <SmartLink
        Component={YStack}
        href={`/discounts/${props.brand.slug}/${props.slug}`}
        flex={1}
        pressStyle={{
          opacity: 0.8,
        }}
        hoverStyle={{
          opacity: 0.9,
        }}
      >
        {props.brand?.logo && (
          <YStack
            zIndex="$1"
            position="absolute"
            aspectRatio={1}
            w={44}
            h={44}
            top="$2"
            left="$2"
            bc="$white"
            boc="$white"
            bw="$1.5"
            br="$3"
            $gtSm={{ w: 66, h: 66, bw: '$2', top: '$3.5', left: '$3.5' }}
            {...shadowStandard}
          >
            <SolitoImage
              src={props.brand.logo.url}
              alt=""
              contentFit="contain"
              style={{ backgroundColor: 'white', borderRadius: 8 }}
              sizes="(max-width: 576px) 44px, 88px"
              fill
            />
          </YStack>
        )}

        {isWeb ? (
          <div
            style={{
              backgroundImage: 'linear-gradient(0deg, rgba(0,0,0,.8), transparent)',
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          />
        ) : (
          <LinearGradient
            width="100%"
            height="100%"
            position="absolute"
            bottom="$0"
            left="$0"
            colors={['$overlay13', '$overlay0']}
            start={[0, 1]}
            end={[0, 0]}
          />
        )}

        <YStack mt="auto" width="100%" gap="$1" p="$3.5">
          <SizableText
            color="$white"
            size="$6"
            fow="800"
            numberOfLines={2}
            $gtXss={{
              size: '$7',
              fow: '800',
            }}
          >
            {props.name}
          </SizableText>
          {props.description && (
            <SizableText size="$3" numberOfLines={2} color="$white">
              {props.description}
            </SizableText>
          )}
        </YStack>
      </SmartLink>
    </YStack>
  )
}
